import { observer } from "mobx-react";
import { lazy, Suspense } from "react";
import BrochurePC from "../../assets/Header/BrochurePC.svg";
import SaveNGrowLogo from "../../assets/Header/SaveNGrowLogo.svg";
import { DataLayerFn } from "../../Configs/API";
import FormStore from "../../Configs/Store/forms";
import { downloadFile } from "../Common/CommonFunctions";
import "./Header.less";
import HeaderNav from "@ipru-common/components/CommonComponents/HandoverHeader/HeaderNav"

const ExtraHeader = lazy(() => {
  return Promise.all([
    import("./ExtraHeader"),
    new Promise((resolve) => setTimeout(resolve, 0)),
  ]).then(([moduleExports]) => moduleExports);
});


const HeaderModule = observer(({ type }) => {
  // type = 1 ? Quote : Landing
  var subSection =
    type === 0 ? "Calculator - Landing Page" : "Calculator-QuoteScreen";
  const BrochureURL =
    "https://www.icicilife.com/content/dam/icicipru/brochures/ICICI_Pru_Save_N_Grow_Brochure.pdf"; // ipru url added due to path issues
  const fileName = "SaveNGrow_Online_Leaflet.pdf";

  const handlemodalOpen = () => {
    // ModalStore.setTalk2Expert(true);
    const talkToExpertSelectedType =
      type === 0 ? "true_landingPage" : "true_quotePage";
    if (
      !window.UserInput.Tollfree_selected.includes(talkToExpertSelectedType)
    ) {
      if (window.UserInput.Tollfree_selected.length > 1)
        window.UserInput.Tollfree_selected += ", " + talkToExpertSelectedType;
      else window.UserInput.Tollfree_selected = talkToExpertSelectedType;
    }
    DataLayerFn(
      `TalkToExpert_Selected||${subSection}|Talk to Expert`,
      FormStore,
      "",
      "Talk to an Expert",
      "",
      "",
    );
    DataLayerFn(
      `TalkToExpert_PopUpOpen||${subSection}|Talk to Expert`,
      FormStore,
      "",
      "Talk to an Expert",
      "",
      "",
    );
  };

  const downloadBrochure = () => {
    const brochureSelectedType =
      type === 0 ? "true_landingPage" : "true_quotePage";
    if (!window.UserInput.brochure_selected.includes(brochureSelectedType)) {
      if (window.UserInput.brochure_selected.length > 1)
        window.UserInput.brochure_selected += ", " + brochureSelectedType;
      else window.UserInput.brochure_selected = brochureSelectedType;
    }
    DataLayerFn(
      `DownloadBrochure||${subSection}|Brochure`,
      FormStore,
      "",
      "Brochure",
      "",
      "",
    );
    downloadFile(BrochureURL, fileName);
  };


  const knowMore = () => {
    window.location =
      "https://www.icicilife.com/retirement-pension-plans/icici-pru-ulip-signature.html?UID=2399";
  };

  const headerProps = {
    productLogo: SaveNGrowLogo,
    productLogoAltText: "ICICI Pru Save N Grow",
    showSeperator:false,
    productOnClick:knowMore,
    brochureText: "Download leaflet",
    brochureFile: BrochureURL,
    onClickBrochureDownload: downloadBrochure,
    onNeedHelpClick: handlemodalOpen,
    openModalRef: true
  }

  return (
    <>
      <div className="BlankClass" style={{ display: "none" }}>
        <Suspense fallback={<div style={{ display: "none" }}></div>}>
          <ExtraHeader />
        </Suspense>
      </div>
      <div className="ipru-common-module">
       <HeaderNav {...headerProps} />
       </div>
    </>
  );
});

export default HeaderModule;
